"use strict";
/* [DISABLED_TEMPORARILY] @ typescript-eslint /camelcase */
Object.defineProperty(exports, "__esModule", { value: true });
var productListingDummy = {
    isoLocale: 'en-AE',
    showMoreLabel: 'Show More',
    showAllLabel: 'Show All',
    moduleData: {
        initialNum: 48,
        moduleHeader: {
            titleText: 'Pots and Pans of noon',
            linkText: 'More Pot?',
            linkUrl: 'https://www.noon.com/pots',
        },
        textColor: '#272727',
        hits: [
            {
                offer_code: 'a9e93e73dcb2900b',
                sku: 'N26226443A',
                sku_config: 'N26226443A',
                brand: 'noon east',
                name: 'Premium Granite/Marble Coated Aluminium Cookware Set With Gold Dots Black/Gold 6-Piece ',
                plp_specifications: {},
                price: 219,
                sale_price: 125,
                url: 'premium-granite-marble-coated-aluminium-cookware-set-with-gold-dots-black-gold-6-piece',
                image_key: 'v1586366431/N26226443A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'd445555859e7a4db',
                sku: 'N19867675A',
                sku_config: 'N19867675A',
                brand: 'royal mark',
                name: '11-Piece Non-Stick Cookware Set Rmcw-9711 Black/Clear ',
                plp_specifications: {},
                price: 119,
                sale_price: 25,
                url: '11-piece-non-stick-cookware-set-rmcw-9711-black-clear',
                image_key: 'v1560858662/N19867675A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'de3564289e6d6bef',
                sku: 'N26502851A',
                sku_config: 'N26502851A',
                brand: 'Amal',
                name: 'Stainless Steel Cookware Set Silver 6-Piece ',
                plp_specifications: {},
                price: 109,
                sale_price: 49,
                url: 'stainless-steel-cookware-set-silver-6-piece',
                image_key: 'v1589983638/N26502851A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'e8b680a5b69e3daa',
                sku: 'N28674755A',
                sku_config: 'N28674755A',
                brand: 'noon east',
                name: 'Aluminium Cookware Set Black 3-Piece (Fry Pan + Sauce Pan) ',
                plp_specifications: {},
                price: 69,
                sale_price: 39,
                url: 'aluminium-cookware-set-black-3-piece-fry-pan-sauce-pan',
                image_key: 'v1586152367/N28674755A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'f0f48c8057be35fd',
                sku: 'N26226452A',
                sku_config: 'N26226452A',
                brand: 'noon east',
                name: 'Non-Stick Aluminium Cookware Set Dark Teal 9-Piece ',
                plp_specifications: {},
                price: 299,
                sale_price: 99,
                url: 'non-stick-aluminium-cookware-set-dark-teal-9-piece',
                image_key: 'v1586260844/N26226452A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'dcac051d5684773d',
                sku: 'N26502541A',
                sku_config: 'N26502541A',
                brand: 'noon east',
                name: 'Stainless Steel Cookware Set Silver 4-Piece ',
                plp_specifications: {},
                price: 98,
                sale_price: 69,
                url: 'stainless-steel-cookware-set-silver-4-piece',
                image_key: 'v1586152353/N26502541A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'ae3a2cbdddb245cd',
                sku: 'N26127389A',
                sku_config: 'N26127389A',
                brand: 'Amal',
                name: 'Non-Stick Aluminium Cookware Set Black 5-Piece ',
                plp_specifications: {},
                price: 129,
                sale_price: 55,
                url: 'non-stick-aluminium-cookware-set-black-5-piece',
                image_key: 'v1589983638/N26127389A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'e86502ed1dea1cba',
                sku: 'N19753385A',
                sku_config: 'N19753385A',
                brand: 'royal mark',
                name: '7-Piece Non-Stick Cookware Set RMCW9700 Clear/Black ',
                plp_specifications: {},
                price: 46.4,
                sale_price: 29,
                url: '7-piece-non-stick-cookware-set-rmcw9700-clear-black',
                image_key: 'v1548161208/N19753385A_1',
                is_buyable: true,
                flags: [],
            },
            {
                offer_code: 'f5929ccd34b4f14b',
                sku: 'N22732041A',
                sku_config: 'N22732041A',
                brand: 'noon east',
                name: 'Non-Stick Aluminium Cookware Set Red 9-Piece ',
                plp_specifications: {},
                price: 250,
                sale_price: 109,
                url: 'non-stick-aluminium-cookware-set-red-9-piece',
                image_key: 'v1586260835/N22732041A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: '43989ae1da048882',
                sku: 'N11061001A',
                sku_config: 'N11061001A',
                brand: 'SONASHI',
                name: '5-Piece Non Stick Enamel Cookware Casserole Set With Lid Blue 16/18/20/22/24centimeter ',
                plp_specifications: {},
                price: 79,
                sale_price: 69,
                url: '5-piece-non-stick-enamel-cookware-casserole-set-with-lid-blue-16-18-20-22-24centimeter',
                image_key: 'v1561028287/N11061001A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: '63ad8ce075314063',
                sku: 'N11060382A',
                sku_config: 'N11060382A',
                brand: 'Prestige',
                name: '17-Piece Cooking Set Red ',
                plp_specifications: {},
                price: 305.8,
                sale_price: 289,
                url: '17-piece-cooking-set-red',
                image_key: 'v1502753559/N11060382A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: '53e64f99fedc01cb',
                sku: 'N11060364A',
                sku_config: 'N11060364A',
                brand: 'Prestige',
                name: '3-Piece Frypan Set Black ',
                plp_specifications: {},
                price: 153,
                sale_price: 80.5,
                url: '3-piece-frypan-set-black',
                image_key: 'v1502753552/N11060364A_1',
                is_buyable: true,
                flags: [],
            },
            {
                offer_code: 'e570a471836cda4b',
                sku: 'N11061000A',
                sku_config: 'N11061000A',
                brand: 'SONASHI',
                name: '3-Piece Enamel Cookware Casserole Set With Lid Blue 18/20/22centimeter ',
                plp_specifications: {},
                price: 59,
                sale_price: 49,
                url: '3-piece-enamel-cookware-casserole-set-with-lid-blue-18-20-22centimeter',
                image_key: 'v1561028286/N11061000A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'ae4478ebff13353d',
                sku: 'N26226445A',
                sku_config: 'N26226445A',
                brand: 'noon east',
                name: 'Premium Granite/Marble Coated Aluminium Cookware Set With Gold Dots Wine/Gold 6-Piece ',
                plp_specifications: {},
                price: 219,
                sale_price: 125,
                url: 'premium-granite-marble-coated-aluminium-cookware-set-with-gold-dots-wine-gold-6-piece',
                image_key: 'v1586366439/N26226445A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'de709f66a29c73bd',
                sku: 'N33336138A',
                sku_config: 'N33336138A',
                brand: 'Dessini',
                name: '17-Piece Granite Cookware Set Rose Gold ',
                plp_specifications: {},
                price: 999,
                sale_price: 314,
                url: '17-piece-granite-cookware-set-rose-gold',
                image_key: 'v1578465798/N33336138A_1',
                is_buyable: true,
                flags: [],
            },
            {
                offer_code: 'ae96383a0d24e5cf',
                sku: 'N22482622A',
                sku_config: 'N22482622A',
                brand: 'Prestige',
                name: 'Winsor 9PC Cast Aluminum Non-Stick Cookware-Beige + \nPrestige Class. Pro Cov Saucepan 0.9L/14Cm Multicolour ',
                plp_specifications: {},
                price: 336,
                sale_price: 304,
                url: 'winsor-9pc-cast-aluminum-non-stick-cookware-beige-prestige-class-pro-cov-saucepan-0-9l-14cm-multicolour',
                image_key: 'v1555908727/N22482622A_1',
                is_buyable: true,
                flags: [],
            },
            {
                offer_code: 'c74779feae4558fa',
                sku: 'N28674753A',
                sku_config: 'N28674753A',
                brand: 'noon east',
                name: 'Aluminium Black 2-Piece (Fry Pan) ',
                plp_specifications: {},
                price: 69,
                sale_price: 29,
                url: 'aluminium-black-2-piece-fry-pan',
                image_key: 'v1586152343/N28674753A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'caf297cde079ba5d',
                sku: 'N26502543A',
                sku_config: 'N26502543A',
                brand: 'Amal',
                name: 'Stainless Steel Cookware Set Silver 18-Piece ',
                plp_specifications: {},
                price: 240,
                sale_price: 129,
                url: 'stainless-steel-cookware-set-silver-18-piece',
                image_key: 'v1589983631/N26502543A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'd8071e410b9627dc',
                sku: 'N36164188A',
                sku_config: 'N36164188A',
                brand: 'Impex',
                name: '4-Piece Induction Bottom Non-Stick Cookware Set Silver/Black/Red ',
                plp_specifications: {},
                price: 169,
                sale_price: 75,
                url: '4-piece-induction-bottom-non-stick-cookware-set-silver-black-red',
                image_key: 'v1585234963/N36164188A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'a70ea96257bf0ebd',
                sku: 'N31367247A',
                sku_config: 'N31367247A',
                brand: 'Dessini',
                name: '19-Piece Cookware Set Purple/Clear ',
                plp_specifications: {},
                price: 321,
                sale_price: null,
                url: '19-piece-cookware-set-purple-clear',
                image_key: 'v1573828140/N31367247A_1',
                is_buyable: true,
                flags: [],
            },
            {
                offer_code: 'f9b7b1bd57a5b88f',
                sku: 'N34009375A',
                sku_config: 'N34009375A',
                brand: 'RAJ',
                name: '5-Piece Steel Cookware Set With Lids Silver ',
                plp_specifications: {},
                price: 59,
                sale_price: null,
                url: '5-piece-steel-cookware-set-with-lids-silver',
                image_key: 'v1580206413/N34009375A_1',
                is_buyable: true,
                flags: [],
            },
            {
                offer_code: 'f85f06719a166f6a',
                sku: 'N26226453A',
                sku_config: 'N26226453A',
                brand: 'noon east',
                name: 'Non-Stick Aluminium Cookware Set Black 12-Piece ',
                plp_specifications: {},
                price: 99,
                sale_price: null,
                url: 'non-stick-aluminium-cookware-set-black-12-piece',
                image_key: 'v1586152332/N26226453A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'f7bdfeff8d438f6f',
                sku: 'N18949133A',
                sku_config: 'N18949133A',
                brand: 'Korkmaz',
                name: '9-Piece Alfa Cookware Set Silver ',
                plp_specifications: {},
                price: 499,
                sale_price: 349,
                url: '9-piece-alfa-cookware-set-silver',
                image_key: 'v1540285899/N18949133A_1',
                is_buyable: true,
                flags: [],
            },
            {
                offer_code: 'a1b60197a410fc3e',
                sku: 'N36436499A',
                sku_config: 'N36436499A',
                brand: 'Tefal',
                name: '2-Piece Tempo Flame Kebbe Oven Dish Set With Gloves Red/Black ',
                plp_specifications: {},
                price: 176,
                sale_price: 119,
                url: '2-piece-tempo-flame-kebbe-oven-dish-set-with-gloves-red-black',
                image_key: 'v1588679745/N36436499A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'd491545f1c39049d',
                sku: 'N12792985A',
                sku_config: 'N12792985A',
                brand: 'ROYALFORD',
                name: '8-Piece Non-stick Cookware Set Red Standard ',
                plp_specifications: {},
                price: 237.26,
                sale_price: 85,
                url: '8-piece-non-stick-cookware-set-red-standard',
                image_key: 'v1583142407/N12792985A_1',
                is_buyable: true,
                flags: [],
            },
            {
                offer_code: 'e182af40f522babc',
                sku: 'N13337126A',
                sku_config: 'N13337126A',
                brand: 'ROYALFORD',
                name: '7-Piece Cookware Set White/Clear ',
                plp_specifications: {},
                price: 258,
                sale_price: 139,
                url: '7-piece-cookware-set-white-clear',
                image_key: 'v1588340205/N13337126A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'd0dfa673ff4fd42d',
                sku: 'N33336131A',
                sku_config: 'N33336131A',
                brand: 'Dessini',
                name: '17-Piece Granite Cookware Set Brown ',
                plp_specifications: {},
                price: 299,
                sale_price: 220,
                url: '17-piece-granite-cookware-set-brown',
                image_key: 'v1578465817/N33336131A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'b47c2cb0ee64a725',
                sku: 'N11060373A',
                sku_config: 'N11060373A',
                brand: 'Prestige',
                name: '3-Piece Classique Frypan And Wok Set Red ',
                plp_specifications: {},
                price: 87.3,
                sale_price: 79,
                url: '3-piece-classique-frypan-and-wok-set-red',
                image_key: 'v1502753551/N11060373A_1',
                is_buyable: true,
                flags: [],
            },
            {
                offer_code: 'f397858780625cbd',
                sku: 'N31747895A',
                sku_config: 'N31747895A',
                brand: 'Dessini',
                name: '10-Piece Granite Cookware Set Grey/Clear ',
                plp_specifications: {},
                price: 499,
                sale_price: 191,
                url: '10-piece-granite-cookware-set-grey-clear',
                image_key: 'v1572515232/N31747895A_1',
                is_buyable: true,
                flags: [],
            },
            {
                offer_code: 'dff9d109d3e22dab',
                sku: 'N20628892A',
                sku_config: 'N20628892A',
                brand: 'ROYALFORD',
                name: '9-Piece Delight Marble Coated Cookware Set Black/Brown ',
                plp_specifications: {},
                price: 450,
                sale_price: 249,
                url: '9-piece-delight-marble-coated-cookware-set-black-brown',
                image_key: 'v1588337780/N20628892A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'b075b505633a7c3c',
                sku: 'N26502540A',
                sku_config: 'N26502540A',
                brand: 'noon east',
                name: 'Stainless Steel Cookware Set Silver 15-Piece ',
                plp_specifications: {},
                price: 399,
                sale_price: 139,
                url: 'stainless-steel-cookware-set-silver-15-piece',
                image_key: 'v1586260838/N26502540A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'ce1da4af3808625e',
                sku: 'N28907184A',
                sku_config: 'N28907184A',
                brand: 'Prestige',
                name: '2-Piece Stainless Steel Frypan Set Silver ',
                plp_specifications: {},
                price: 119,
                sale_price: null,
                url: '2-piece-stainless-steel-frypan-set-silver',
                image_key: 'v1564744875/N28907184A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'e5b96ccf3ca5e2dd',
                sku: 'N36164185A',
                sku_config: 'N36164185A',
                brand: 'Impex',
                name: '2-Piece 3-Liter Cooker & Induction Bottom Cookware Set Silver/Black/Red ',
                plp_specifications: {},
                price: 179,
                sale_price: 75,
                url: '2-piece-3-liter-cooker-induction-bottom-cookware-set-silver-black-red',
                image_key: 'v1585234960/N36164185A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'ecf22e4b828bfbda',
                sku: 'N32052378A',
                sku_config: 'N32052378A',
                brand: null,
                name: 'Pack Of 2 Chopsticks Spoon Suit Red/Silver 18.5x18.7centimeter ',
                plp_specifications: {},
                price: 9.95,
                sale_price: null,
                url: 'pack-of-2-chopsticks-spoon-suit-red-silver-18-5x18-7centimeter',
                image_key: 'v1574149434/N32052378A_1',
                is_buyable: true,
                flags: [],
            },
            {
                offer_code: 'ea77ee85bcdacd4e',
                sku: 'N12793226A',
                sku_config: 'N12793226A',
                brand: 'ROYALFORD',
                name: '8-Piece Non-Stick Cookware Set Red ',
                plp_specifications: {},
                price: 280,
                sale_price: 99,
                url: '8-piece-non-stick-cookware-set-red',
                image_key: 'v1579507150/N12793226A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'acba98d6ec8d7a6a',
                sku: 'N21109497A',
                sku_config: 'N21109497A',
                brand: 'Penguen',
                name: '7-Piece Granitec Cookware Set Black/Dark Grey ',
                plp_specifications: {},
                price: 743,
                sale_price: 289,
                url: '7-piece-granitec-cookware-set-black-dark-grey',
                image_key: 'v1550047700/N21109497A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'aff7363c9c6bec2e',
                sku: 'N18949134A',
                sku_config: 'N18949134A',
                brand: 'Korkmaz',
                name: '9-Piece Gala Cookware Set Silver ',
                plp_specifications: {},
                price: 449,
                sale_price: 319,
                url: '9-piece-gala-cookware-set-silver',
                image_key: 'v1540285896/N18949134A_1',
                is_buyable: true,
                flags: [],
            },
            {
                offer_code: 'dcae78a6db4901ff',
                sku: 'N20628956A',
                sku_config: 'N20628956A',
                brand: 'ROYALFORD',
                name: '10-Piece Korean Cookware Set Pink/Black ',
                plp_specifications: {},
                price: 599,
                sale_price: 268,
                url: '10-piece-korean-cookware-set-pink-black',
                image_key: 'v1553258512/N20628956A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'f0f2f4930c032d3f',
                sku: 'N36002666A',
                sku_config: 'N36002666A',
                brand: 'Tefal',
                name: '3-Piece Cook N Clean Aluminum Set Red 43x4x25.6centimeter ',
                plp_specifications: {},
                price: 127,
                sale_price: 99,
                url: '3-piece-cook-n-clean-aluminum-set-red-43x4x25-6centimeter',
                image_key: 'v1584533768/N36002666A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'd8fab6c9b2601cbf',
                sku: 'N35033930A',
                sku_config: 'N35033930A',
                brand: 'ROYALFORD',
                name: '4-Piece Cookware Set Multicolour 2.8 x 2.8 x 2.4inch ',
                plp_specifications: {},
                price: 250,
                sale_price: 99,
                url: '4-piece-cookware-set-multicolour-2-8-x-2-8-x-2-4inch',
                image_key: 'v1591356318/N35033930A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'dcc73202aea00de5',
                sku: 'N11060368A',
                sku_config: 'N11060368A',
                brand: 'Prestige',
                name: '6-Piece Cooking Pot Set Red ',
                plp_specifications: {},
                price: 241,
                sale_price: 209,
                url: '6-piece-cooking-pot-set-red',
                image_key: 'v1574162418/N11060368A_3',
                is_buyable: true,
                flags: [],
            },
            {
                offer_code: 'fdf09edfb0e5131e',
                sku: 'N19492455A',
                sku_config: 'N19492455A',
                brand: 'Opalina',
                name: '9-Piece  Granite Coated Cookware Set Pink ',
                plp_specifications: {},
                price: 600,
                sale_price: 298,
                url: '9-piece-granite-coated-cookware-set-pink',
                image_key: 'v1557487745/N19492455A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'b4cffbf3b31a622b',
                sku: 'N35314373A',
                sku_config: 'N35314373A',
                brand: 'Tefal',
                name: '7-Piece Non Stick Cookware Set Black/Clear ',
                plp_specifications: {},
                price: 110,
                sale_price: null,
                url: '7-piece-non-stick-cookware-set-black-clear',
                image_key: 'v1584005068/N35314373A_1',
                is_buyable: true,
                flags: [],
            },
            {
                offer_code: 'db373d09759d410c',
                sku: 'N33336132A',
                sku_config: 'N33336132A',
                brand: 'Dessini',
                name: '17-Piece Granite Cookware Set Blue/Clear ',
                plp_specifications: {},
                price: 999,
                sale_price: 232,
                url: '17-piece-granite-cookware-set-blue-clear',
                image_key: 'v1578465816/N33336132A_1',
                is_buyable: true,
                flags: [],
            },
            {
                offer_code: 'e513cd495a9c5edb',
                sku: 'N38086416A',
                sku_config: 'N38086416A',
                brand: 'BerlingerHaus',
                name: '10-Piece Metallic Line Carbon Edition Cookware Set Carbon ',
                plp_specifications: {},
                price: 499,
                sale_price: 299.4,
                url: '10-piece-metallic-line-carbon-edition-cookware-set-carbon',
                image_key: 'v1590587910/N38086416A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'c783871d0d83512a',
                sku: 'N36164186A',
                sku_config: 'N36164186A',
                brand: 'Impex',
                name: '2-Piece 5-Liter Cooker & Induction Bottom Cookware Set Silver/Black/Red ',
                plp_specifications: {},
                price: 169,
                sale_price: 76,
                url: '2-piece-5-liter-cooker-induction-bottom-cookware-set-silver-black-red',
                image_key: 'v1585234961/N36164186A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'ee663fc4a75629bb',
                sku: 'N38342232A',
                sku_config: 'N38342232A',
                brand: 'Royal NBL',
                name: '5-Piece Aluminium Belly Shape Cookware Set With Lid Silver ',
                plp_specifications: {},
                price: 129,
                sale_price: 119,
                url: '5-piece-aluminium-belly-shape-cookware-set-with-lid-silver',
                image_key: 'v1590849919/N38342232A_1',
                is_buyable: true,
                flags: [],
            },
            {
                offer_code: 'd20af7fc148689ea',
                sku: 'N35345920A',
                sku_config: 'N35345920A',
                brand: 'VINOD',
                name: '9-Piece Cookware Set Silver ',
                plp_specifications: {},
                price: 159,
                sale_price: 99,
                url: '9-piece-cookware-set-silver',
                image_key: 'v1584083499/N35345920A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
            {
                offer_code: 'afa5e496b07fcc6d',
                sku: 'N31654579A',
                sku_config: 'N31654579A',
                brand: 'Delcasa',
                name: '8-Piece Stainless Steel Cookware Set Silver 24x11.5centimeter ',
                plp_specifications: {},
                price: 299,
                sale_price: 89,
                url: '8-piece-stainless-steel-cookware-set-silver-24x11-5centimeter',
                image_key: 'v1572847115/N31654579A_1',
                is_buyable: true,
                flags: [],
            },
            {
                offer_code: '516baf8badbcc18d',
                sku: 'N11060366A',
                sku_config: 'N11060366A',
                brand: 'Prestige',
                name: '9-Piece Value Pack Set Red ',
                plp_specifications: {},
                price: 214,
                sale_price: 184,
                url: '9-piece-value-pack-set-red',
                image_key: 'v1583497745/N11060366A_1',
                is_buyable: true,
                flags: ['fbn'],
            },
        ],
    },
    productBox: {
        locale: undefined,
        renderCatalogTag: undefined,
        renderFulfilmentBox: undefined,
        renderLimitedDealBar: undefined,
        renderFrenzyDealBar: undefined,
        renderPrice: undefined,
        cartContext: undefined,
        customerContext: undefined,
        appConfig: undefined,
        navContext: undefined,
        t: undefined,
        product: {},
    },
};
exports.default = productListingDummy;
//# sourceMappingURL=productListingDummy.js.map